import { render, staticRenderFns } from "./notification-prescription-dialog.vue?vue&type=template&id=44f3967c&scoped=true&lang=pug&"
import script from "./notification-prescription-dialog.vue?vue&type=script&lang=ts&"
export * from "./notification-prescription-dialog.vue?vue&type=script&lang=ts&"
import style0 from "./notification-prescription-dialog.vue?vue&type=style&index=0&id=44f3967c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44f3967c",
  null
  
)

export default component.exports